// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sg-9";
export var arrowButtonContainer = "_sg-5";
export var arrowButtonIcon = "_sg-6";
export var carouselArrowButton = "_sg-2";
export var carouselElementContainer = "_sg-1";
export var currentSlide = "_sg-8";
export var left = "_sg-3";
export var otherSlide = "_sg-a";
export var productCarouselContainer = "_sg-0";
export var right = "_sg-4";
export var sliderOverflow = "_sg-7";